import { render, staticRenderFns } from "./AlterationFlk.vue?vue&type=template&id=1b2ee1a8&"
import script from "./AlterationFlk.vue?vue&type=script&lang=js&"
export * from "./AlterationFlk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports